import requests from "./httpService";

const LocationServices = {

    getLocation: async () =>{
        return requests.get(`/location`);
    },
    updateLocation : async (id,body) =>{
        return requests.patch(`/location/${id}`,body);
    },

    createLocation : async (body) =>{
  
        return requests.post(`/location`,body);
    },
    deleteLocation : async (id) =>{
        return requests.delete(`/location/${id}`);
    },

     updatePincode : async (id,body) =>{
        return requests.post(`/newlocation/pincode/update/${id}`,body);
    },
  


}
export default LocationServices;